import { cloneElement, ReactElement } from 'react';

import DownloadReport from './DownloadReport';
import type { IncidentActionButtonVariant } from '../incidentmanagement/components/incidentActionButton';

import { useRiskIndicator } from '../riskindicators/useRiskIndicator';
import { entriesToNormalizedRedmineArray } from '@/utils/normalizeRedmineArrayProp';
import type { DocumentProps } from '@react-pdf/renderer';

type RelevancyProp = {
  relevancy?: {
    industries: unknown[];
    locations: unknown[];
    technologies: unknown[];
  };
};

interface DownloadTriggerProps {
  name: string;
  document: ReactElement<DocumentProps & RelevancyProp>;
  relevancy?: Record<string, any>;
  fullButton?: boolean;
  buttonVariant?: IncidentActionButtonVariant;
}

const DownloadTrigger = ({
  name,
  document,
  relevancy,
  fullButton,
  buttonVariant,
}: DownloadTriggerProps) => {
  const { hasIndicator: hasRelevantIndustries, relevantContext: relevantIndustries } =
    useRiskIndicator({
      context:
        typeof relevancy?.industries === 'object' &&
        relevancy?.industries !== null &&
        !Array.isArray(relevancy?.industries)
          ? entriesToNormalizedRedmineArray(relevancy?.industries)
          : relevancy?.industries,
      indicator: 'relevant_industry_sectors',
    });
  const { hasIndicator: hasRelevantLocations, relevantContext: relevantLocations } =
    useRiskIndicator({
      context:
        typeof relevancy?.locations === 'object' &&
        relevancy?.locations !== null &&
        !Array.isArray(relevancy?.industries)
          ? entriesToNormalizedRedmineArray(relevancy?.locations)
          : relevancy?.locations,
      indicator: 'relevant_locations',
    });
  const { hasIndicator: hasRelevantTechnologies, relevantContext: relevantTechnologies } =
    useRiskIndicator({
      context:
        typeof relevancy?.technologies === 'object' &&
        relevancy?.technologies !== null &&
        !Array.isArray(relevancy?.industries)
          ? entriesToNormalizedRedmineArray(relevancy?.technologies)
          : relevancy?.technologies,
      indicator: 'relevant_technologies',
    });

  const clonedElement = cloneElement(document, {
    relevancy: {
      industries: hasRelevantIndustries ? relevantIndustries : [],
      locations: hasRelevantLocations ? relevantLocations : [],
      technologies: hasRelevantTechnologies ? relevantTechnologies : [],
    },
  });

  return (
    <DownloadReport
      document={clonedElement}
      label="Download Report"
      asButton={fullButton}
      buttonVariant={buttonVariant}
      fileName={name}
    />
  );
};

export default DownloadTrigger;
